import React from "react";
import "./index.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import IconNew from "components/elements/iconsSize";

export const TYPES = {
    regular: "regular",
    regularMin: "regularMin",
    regularLarge: "regularLarge",
    regular153: "regular153",
    medium: "medium",
    bold: "bold",
    bold100: "bold100",
    regularDefault: "regularDefault",
    regularDefaultSmall: "regularDefaultSmall",
    select: "select",
    select_large: "select_large",
    mediumLarge: "mediumLarge",
    medium153: "medium153",
    medium160: "medium160",
    mediumLargeGrey: "mediumLargeGrey",
    mediumSmall: "mediumSmall",
    regularDefaultSmallX: "regularDefaultSmallX",
    regular148: "regular148",
    regular160: "regular160",
    regularDefaultGrey: "regularDefaultGrey",
    regularDefaultGrey145: "regularDefaultGrey145",
    regularDefault145: "regularDefault145",
    medium150: "medium150",
    mediumXSmall: "mediumXSmall",
    medium140: "medium140",
    bold133: "bold133",
    bold800: "bold800",
    bold900: "bold900"
};

export const SIZES = {
    xlarge: "xlarge",
    xxlarge: "xxlarge",
    size_40: "size_40",
    large: "large",
    medium: "medium",
    small: "small",
    xsmall: "xsmall",
    xx_small: "xx_small",
    size_28: "size_28",
    size_30: "size_30",
    size_54: 'size_54',
};

export const TextWithIcon = ({
    className,
    inner,
    type,
    size,
    style,
    onClick,
    tooltip,
    iconName,
    isWithoutIcon,
    iconGap,
    generalStyles,
    iconProps,
    isIconRight,
    iconColor,
    classNameActive
}) => {
    return (
        <div
            role="presentation"
            onClick={onClick}
            style={{ gap: iconGap || 11, ...generalStyles }}
            className={classNames(classNameActive, "text-with-icon")}
        >
            {!isWithoutIcon &&
                !isIconRight && (
                    <IconNew
                        color={iconColor}
                        name={iconName || "LeftArrowL"}
                        {...iconProps}
                    />
                )}
            <span
                style={style}
                className={classNames(
                    className,
                    "textBasic",
                    "dont-break-out",
                    {
                        [`textBasic_type_${type}`]: type,
                        [`textBasic_size_${size}`]: size
                    },
                    "flex-1"
                )}
            >
                {inner}
            </span>
            {!isWithoutIcon &&
                isIconRight && (
                    <IconNew name={iconName || "LeftArrowL"} {...iconProps} />
                )}
        </div>
    );
};

export const TextWithTooltip = ({
    className,
    inner,
    type,
    size,
    style,
    onClick,
    tooltip,
    iconName,
    iconGap,
    generalStyles,
    isIconRigth
}) => {
    return (
        <div
            role="presentation"
            onClick={onClick}
            className="text-with-icon"
            style={{ gap: iconGap || 11, ...generalStyles }}
        >
            <span
                style={style}
                className={classNames(
                    className,
                    "textBasic",
                    "dont-break-out",
                    {
                        [`textBasic_type_${type}`]: type,
                        [`textBasic_size_${size}`]: size
                    }
                )}
            >
                {inner}
            </span>
        </div>
    );
};

const Text = ({
    className,
    inner,
    type,
    size,
    style,
    onClick,
    tooltip,
    miniText,
    isTitle,
    isSubtitle
}) => {
    return (
        <>
           {!isTitle && !isSubtitle &&  <span
                style={style}
                role="presentation"
                onClick={onClick}
                className={classNames(
                    className,
                    "textBasic",
                    "dont-break-out",
                    {
                        [`textBasic_type_${type}`]: type,
                        [`textBasic_size_${size}`]: size
                    }
                )}
            >
                {Array.isArray(inner)
                    ? inner.map((child, index) => {
                        if (typeof child === "string") return child;
                        return React.cloneElement(child, {
                            key: index.toString()
                        });
                    })
                    : inner}
                {!!`${miniText}` && (
                    <span className="mini-text">{miniText}</span>
                )}
            </span>}
            {isTitle &&  <h1
                style={style}
                role="presentation"
                onClick={onClick}
                className={classNames(
                    className,
                    "textBasic",
                    "dont-break-out",
                    {
                        [`textBasic_type_${type}`]: type,
                        [`textBasic_size_${size}`]: size
                    }
                )}
            >
                {Array.isArray(inner)
                    ? inner.map((child, index) => {
                        if (typeof child === "string") return child;
                        return React.cloneElement(child, {
                            key: index.toString()
                        });
                    })
                    : inner}
                {!!`${miniText}` && (
                    <span className="mini-text">{miniText}</span>
                )}
                <span style={{display: 'none'}}>online course</span>
                <h2 style={{display: 'none'}}>builder</h2>
                <h3 style={{display: 'none'}}>course platform</h3>
                <h4 style={{display: 'none'}}>online</h4>
            </h1>}
            {isSubtitle &&  <h2
                style={style}
                role="presentation"
                onClick={onClick}
                className={classNames(
                    className,
                    "textBasic",
                    "dont-break-out",
                    {
                        [`textBasic_type_${type}`]: type,
                        [`textBasic_size_${size}`]: size
                    }
                )}
            >
                {Array.isArray(inner)
                    ? inner.map((child, index) => {
                        if (typeof child === "string") return child;
                        return React.cloneElement(child, {
                            key: index.toString()
                        });
                    })
                    : inner}
                {!!`${miniText}` && (
                    <span className="mini-text">{miniText}</span>
                )}
            </h2>}
        </>
    );
};

export const TextDocument = ({
    className,
    inner,
    type,
    size,
    style,
    onClick,
    tooltip,
    miniText
}) => {
    return (
        <>
            <span
                style={style}
                role="presentation"
                onClick={onClick}
                className={classNames(
                    className,
                    "textBasic",
                    "dont-break-out",
                    {
                        [`textBasic_type_${type}`]: type,
                        [`textBasic_size_${size}`]: size
                    }
                )}
            >
                <div dangerouslySetInnerHTML={{ __html: inner }}></div>
                {!!`${miniText}` && (
                    <span className="mini-text">{miniText}</span>
                )}
            </span>
        </>
    );
};

export const TextColumn = ({ texts, alignItems, ...props }) => {
    return (
        <div
            className="text__column"
            style={{ alignItems: alignItems || "center" }}
        >
            {texts.map(e => {
                return <Text {...props} inner={e} />;
            })}
        </div>
    );
};

TextColumn.propTypes = {
    texts: PropTypes.array,
    alignItems: PropTypes.string
};

TextWithIcon.propTypes = {
    size: PropTypes.string,
    type: PropTypes.string,
    inner: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.number,
        PropTypes.node
    ]),
    style: PropTypes.any,
    className: PropTypes.string,
    onClick: PropTypes.func,
    tooltip: PropTypes.string,
    iconName: PropTypes.string,
    isWithoutIcon: PropTypes.bool,
    iconColor: PropTypes.string,
    iconGap: PropTypes.number,
    generalStyles: PropTypes.any,
    isIconRight: PropTypes.bool,
    iconProps: PropTypes.object,
    classNameActive: PropTypes.string
};

TextWithIcon.defaultProps = {
    type: "medium",
    size: "large",
    inner: "Text",
    onClick: () => { },
    isIconRight: false,
    iconProps: {}
};

Text.propTypes = {
    size: PropTypes.string,
    type: PropTypes.string,
    miniText: PropTypes.any,
    inner: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.number,
        PropTypes.node
    ]),
    style: PropTypes.any,
    className: PropTypes.string,
    onClick: PropTypes.func,
    tooltip: PropTypes.string,
    isTitle: PropTypes.bool,
};

TextDocument.propTypes = {
    size: PropTypes.string,
    type: PropTypes.string,
    miniText: PropTypes.any,
    inner: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.number,
        PropTypes.node
    ]),
    style: PropTypes.any,
    className: PropTypes.string,
    onClick: PropTypes.func,
    tooltip: PropTypes.string
}

Text.defaultProps = {
    type: "medium",
    size: "large",
    inner: "Text",
    onClick: () => { }
};

TextWithTooltip.propTypes = {
    size: PropTypes.string,
    type: PropTypes.string,
    inner: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.number,
        PropTypes.node
    ]),
    style: PropTypes.any,
    className: PropTypes.string,
    onClick: PropTypes.func,
    tooltip: PropTypes.string,
    iconName: PropTypes.string,
    iconGap: PropTypes.number,
    generalStyles: PropTypes.any,
    isIconRigth: PropTypes.bool
};

export default Text;
